(function($){
    // JS
    window.Sliders = {

        // Theme Carousel
        //======================================================================
        carousels: function()
        {
            var swiper = new Swiper('.swiper-container', {
                grabCursor: false,
                allowTouchMove: true,
                items: 1,
                autoplay: true,
                speed: 3000,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    768: {
                        allowTouchMove: false,
                    }
                },
            });
        }
    }
    // Run
    $(function(){
        Sliders.carousels();
    });


}(jQuery));